<template>
    <van-pull-refresh
            style="min-height: 100vh"
            v-model="isLoading"
            success-text="刷新成功"
            @refresh="onRefresh"
    >
        <!-- 用户信息 -->
        <div class="card radio">
            <van-row style="padding-top: 10px">
                <van-col span="2" />
                <van-col span="22" class="text">
                    <p>用户名 : {{ name }}</p>
                    <p>手机号 : {{ phone }}</p>
                    <p>设备号 : {{ Imei }}</p>
                    <p>到期时间 : {{ end_Time }}</p>
                    <p>账号状态 : {{ status }}</p>
                    <p style="display: flex; align-items: center;">
                        官方网址 : www.Telegram.cn
                        <span
                                @click="showNotif()"
                                data-clipboard-text="www.telegram.cn"
                                class="q_read"
                                style="margin-left: 4px; cursor: pointer;"
                        >
              <van-image
                      :src="require('../assets/B1.png')"
                      width="1.0rem"
                      height="1.0rem"
                      class="icon1"
              />
            </span>
                    </p>
                    <p>联系客服 : <span @click="addgroup('@TG_xiaobaobei')">Telegram中文版</span></p>
<!--                    <p><span @click="addgroup('@TG_cnpindao')">TG中文版 频道</span></p>-->
<!--                    <p><span @click="addgroup('@TG_cnqunzu')">TG中文版 群组</span></p>-->
                </van-col>
                <van-col span="1" />
            </van-row>
        </div>

        <!-- 四张会员卡 -->
        <div class="radio card2">
            <p class="member">安卓会员</p>
            <div style="padding: 10px">
                <van-row gutter="20">
                    <van-col span="12">
                        <div class="radio card3 bg12" @click="buy(packages[0])">
                            <van-row>
                                <van-col span="15">
                                    <p class="me_text">一月会员</p>
                                </van-col>
                                <van-col span="4">
                                    <van-image
                                            round
                                            style="margin-left: 20px;margin-top: 10px"
                                            width="1.5rem"
                                            height="1.5rem"
                                            fit="cover"
                                            :src="currentIcon"
                                    />
                                </van-col>
                            </van-row>
                            <van-icon name="diamond" size="1.5rem" color="#FFEB3B" class="icon" />
                            <span class="money">￥ 38</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="radio card3 bg1" @click="buy(packages[1])">
                            <van-row>
                                <van-col span="15">
                                    <p class="me_text">一季会员</p>
                                </van-col>
                                <van-col span="4">
                                    <van-image
                                            round
                                            style="margin-left: 20px;margin-top: 10px"
                                            width="1.5rem"
                                            height="1.5rem"
                                            fit="cover"
                                            :src="currentIcon"
                                    />
                                </van-col>
                            </van-row>
                            <van-icon name="fire" size="1.5rem" color="#0082c8" class="icon" />
                            <span class="money">￥ 98</span>
                        </div>
                    </van-col>
                </van-row>

                <van-row gutter="20">
                    <van-col span="12">
                        <div class="radio card3 bg2" @click="buy(packages[2])">
                            <van-row>
                                <van-col span="15">
                                    <p class="me_text">半年会员</p>
                                </van-col>
                                <van-col span="4">
                                    <van-image
                                            round
                                            style="margin-left: 20px;margin-top: 10px"
                                            width="1.5rem"
                                            height="1.5rem"
                                            fit="cover"
                                            :src="currentIcon"
                                    />
                                </van-col>
                            </van-row>
                            <van-icon name="award" size="1.5rem" color="#ffefba" class="icon" />
                            <span class="money">￥ 168</span>
                        </div>
                    </van-col>
                    <van-col span="12">
                        <div class="radio card3 bg3" @click="buy(packages[3])">
                            <van-row>
                                <van-col span="15">
                                    <p class="me_text">一年会员</p>
                                </van-col>
                                <van-col span="4">
                                    <van-image
                                            round
                                            style="margin-left: 20px;margin-top: 10px"
                                            width="1.5rem"
                                            height="1.5rem"
                                            fit="cover"
                                            :src="currentIcon"
                                    />
                                </van-col>
                            </van-row>
                            <van-icon name="vip-card" size="1.5rem" color="#ffffff" class="icon" />
                            <span class="money">￥ 298</span>
                        </div>
                    </van-col>
                </van-row>

                <!-- 支付通道切换 -->
                <van-radio-group
                        v-model="payChannel"
                        :key="renderKey"
                        @change="switchChannel"
                >
                    <van-cell
                            title="支付宝"
                            clickable
                            @click="payChannel = 'alipay'"
                            style="align-items: center"
                    >
                        <template #right-icon>
                            <div style="display: flex; margin-right: 140px">
                                <van-image
                                        width="3.2rem"
                                        height="2rem"
                                        fit="cover"
                                        :src="require('../assets/alipay.svg')"
                                />
                            </div>
                            <van-radio name="alipay" />
                        </template>
                    </van-cell>

                    <van-cell title="信用卡" clickable @click="payChannel = 'card'">
                        <template #right-icon>
                            <div style="display: flex; margin-right: 10px">
                                <van-image
                                        width="2.2rem"
                                        height="1.4rem"
                                        fit="cover"
                                        :src="require('../assets/unionpay.svg')"
                                        style="margin-right: 2px"
                                />
                                <van-image
                                        width="2.2rem"
                                        height="1.4rem"
                                        fit="cover"
                                        :src="require('../assets/visa.svg')"
                                        style="margin-right: 2px"
                                />
                                <van-image
                                        width="2.2rem"
                                        height="1.4rem"
                                        fit="cover"
                                        :src="require('../assets/mastercard.svg')"
                                        style="margin-right: 2px"
                                />
                                <van-image
                                        width="2.2rem"
                                        height="1.4rem"
                                        fit="cover"
                                        :src="require('../assets/jcb.svg')"
                                        style="margin-right: 2px"
                                />
                                <van-image
                                        width="2.2rem"
                                        height="1.4rem"
                                        fit="cover"
                                        :src="require('../assets/amex.svg')"
                                />
                            </div>
                            <van-radio name="card" />
                        </template>
                    </van-cell>
                </van-radio-group>
            </div>
        </div>

        <!-- 下载链接 -->
        <div class="radio card1">
            <p class="member">下载链接</p>
            <div style="padding: 10px">
                <van-cell-group>
                    <van-cell>
                        <template #title>
              <span class="custom-title" style="display: flex; align-items: center">
                <van-row>
                  <van-col span="2">
                    <van-image
                            width="1.1rem"
                            height="1.1rem"
                            fit="cover"
                            :src="require('../assets/android_logo.png')"
                            style="display: inline-block"
                    />
                  </van-col>
                  <van-col span="21" class="text1">
                    <span>www.Telegram.cn/android.apk</span>
                  </van-col>
                </van-row>
              </span>
                        </template>
                        <span
                                @click="showNotif()"
                                data-clipboard-text="www.telegram.cn/android.apk"
                                class="q_read"
                                style="margin-left: 4px"
                        >
              <van-image
                      :src="require('../assets/B.png')"
                      width="1.0rem"
                      height="1.0rem"
                      class="icon2"
              />
            </span>
                    </van-cell>
                </van-cell-group>
            </div>
        </div>

        <!-- 支付结果弹窗（仅支付宝用） -->
        <van-dialog
                v-model="qr_show"
                show-cancel-button
                confirm-button-text="支付完成"
                @confirm="_confirm"
        >
            <template #title>
        <span style="font-weight: bold">
          {{ payChannel === 'alipay' ? '支付宝扫码支付' : '信用卡支付' }}
        </span>
            </template>
            <van-image :src="qrcode" width="20rem" height="20rem">
                <template v-slot:loading><van-loading type="spinner" size="30" /></template>
            </van-image>
        </van-dialog>
    </van-pull-refresh>
</template>

<script>
    import { Toast } from 'vant'

    export default {
        name: 'HelloWorld',
        data () {
            return {
                isLoading: false,
                Imei: null,
                name: null,
                phone: null,
                end_Time: null,
                status: null,
                qrcode: null,
                qr_show: false,
                order_sn: null,
                renderKey: 0,
                payChannel: 'alipay', // 默认支付宝
                packages: [
                    { buy_num: 1, total_amount: 38 },
                    { buy_num: 3, total_amount: 98 },
                    { buy_num: 6, total_amount: 168 },
                    { buy_num: 12, total_amount: 298 }
                ]
            }
        },
        computed: {
            currentIcon () {
                return this.payChannel === 'alipay'
                    ? require('../assets/zhipay.jpg')
                    : require('../assets/cardpay.png')
            }
        },
        mounted () {
            window.ftest = this.ftest
            this.getCurrencyUser()
        },

        methods: {
            /* 实时汇率 → 港币分，最低 4 HKD */
            async getRate () {
                try {
                    const res = await fetch('https://api.exchangerate-api.com/v4/latest/CNY')
                    const json = await res.json()
                    const rate = json.rates.HKD

                    // 验证汇率合理性：正常应该在 1.0 - 1.2 之间
                    if (rate < 1.0 || rate > 1.2) {
                        console.error('汇率 API 异常，使用备用值:', rate)
                        return 1.1
                    }

                    return rate
                } catch (e) {
                    console.error('汇率 API 请求失败:', e)
                    return 1.1
                }
            },

            /* 统一购买：人民币展示，港元分结算 */
            async buy (pkg) {
                try {
                    localStorage.setItem('lastPayCh', this.payChannel)
                } catch (e) {
                    // 忽略写入失败，继续支付
                }
                const tradeType = this.payChannel === 'alipay' ? 'Stripe_alipay' : 'bank_card'
                const rate = await this.getRate()
                const hkdCent = Math.max(Math.round(pkg.total_amount * rate * 100), 400)

                // 把当前通道写回回调，返回时可恢复
                const returnUrl = `https://wode.tgzhongwen.com/?channel=${this.payChannel}`
                this.$axios.post(
                    'https://zhifu.tgzhongwen.com/charge/create',
                    this.$qs.stringify({
                        buy_num: pkg.buy_num,
                        total_amount: hkdCent,   // 实时港币分
                        trade_type: tradeType,
                        callback_url: returnUrl,
                        Imei: this.Imei
                    }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                ).then(res => {
                    if (tradeType === 'bank_card') {
                        window.open(res.data.data.pay_url, '_blank')
                    } else {
                        this.qrcode = res.data.data.qrcode
                        this.order_sn = res.data.data.order_sn
                        this.qr_show = true
                    }
                }).catch(err => {
                    console.log(err)
                    Toast({ message: '网络错误！请稍候再试', position: 'top' })
                })
            },

            switchChannel () { /* 仅切换图标 */ },

            _confirm () {
                let tries = 3;                       // 最多 3 次
                const check = async () => {
                    const res = await this.$axios.post(
                        'https://zhifu.tgzhongwen.com/charge/check_status',
                        this.$qs.stringify({ order_sn: this.order_sn })
                    );
                    if (res.data.status == 1) {
                        this.$toast({ message: '支付成功', position: 'top' });
                        this.ftest(this.Imei);
                        return;                            // 成功就结束
                    }
                    tries--;
                    if (tries > 0) {
                        setTimeout(check, 2000);           // 2 秒后重试
                    } else {
                        this.$toast({ message: '支付未完成', position: 'top' });
                    }
                };
                check();                               // 立即开始第一轮
            },


            onRefresh () {
                setTimeout(() => {
                    location.reload()
                    Toast('刷新成功')
                    this.isLoading = false
                }, 1200)
            },

            showNotif () {
                const clipboard = new this.Clipboard('.q_read')
                clipboard.on('success', e => {
                    this.$notify({ type: 'success', message: '复制成功' })
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    this.$notify({ type: 'warning', message: '复制失败' })
                })
            },

            ftest (Imei) {
                this.Imei = Imei
                this.$axios.post(
                    'https://zhifu.tgzhongwen.com/charge/serviceValid',
                    this.$qs.stringify({ Imei: this.Imei }),
                    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                ).then(res => {
                    this.end_Time = res.data.end_at
                    this.status = res.data.status === 1 ? '账号仍在服务期' : '账号已到期'
                })
            },

            getCurrencyUser () {
                let userstr = $App.getCurrencyUser();
                let str = String(userstr).split(';');
                this.name = str[1].replace('null', '');
                this.phone = '+'+str[0];
            },

            addgroup(val) {
                console.log(val);
                /*约定的url协议为：js://webview?arg1=111&arg2=222*/
                document.location = "appjs://webview?path=" + val;
                console.log(document.location);
            },
        }
    }
</script>


<style scoped lang="css">
    .my-cell-group {
        padding: 5px 0px 0px 0px; /* 上下 20px，左右 0 */
    }
    .card {
        width: auto;
        height: 240px;
        background: linear-gradient(to top right, #1c2a38, #3c1240, #000000);
        margin: 20px 10px 20px 10px;
    }

    .card1 {
        width: auto;
        background-color: white;
        margin: 20px 10px;
        padding-top: 6px;
    }

    .card2 {
        width: auto;
        /*height: 330px;*/
        background-color: #ffffff;
        padding-top: 1px;
        margin: 20px 20px;
    }

    .card3 {
        width: 100%;
        height: 80px;
        padding-top: 0.5px;
    }

    .card4 {
        width: auto;
        height: 230px;
        background-color: #ffffff;
        padding-top: 1px;
        margin: 20px 20px;
    }

    .bg1 {
        background: linear-gradient(to top right, #CDDC39, #8BC34A, #FFEB3B);
    }

    .bg2 {
        background: linear-gradient(to top right, #41dc98, #3bbfc3, #44b8ff);
    }

    .bg3 {
        background: linear-gradient(to top right, #4d31dc, #7e2fc3, #d938ff);
    }

    .bg4 {
        background: linear-gradient(to top right, #ff512f, #dd2476);
    }

    .bg5 {
        background: linear-gradient(to top right, #56174a, #620c43);
    }

    .bg6 {
        background: linear-gradient(to top right, #264a3f, #263956);
    }

    .bg7 {
        background: linear-gradient(to top right, #55561d, #623321);
    }

    .bg8 {
        background: linear-gradient(to top right, #2c4a29, #2e3456);
    }
    .bg9 {
        background: linear-gradient(to top right, #6a3093, #a044ff);
    }
    .bg10 {
        background: linear-gradient(to top right, #3a7bd5, #3a6073);
    }
    .bg11 {
        background: linear-gradient(to top right, #f857a6, #ff5858);
    }
    .bg12 {
        background: linear-gradient(to top right, #da4453, #89216b);
    }
    .bg13 {
        background: linear-gradient(to top right, #667eea, #764ba2);
    }
    .bg14 {
        background: linear-gradient(to top right, #16d9e3, #46aef7);
    }
    .bg15 {
        background: linear-gradient(to top right, #ff5858, #f09819);
    }
    .bg16 {
        background: linear-gradient(to top right, #c471f5, #fa71cd);
    }

    .radio {
        margin-bottom: 10px;
        border-radius: 5px;
    }

    .text {
        color: #dcdcdc;
        font-size: 14px;
    }
    .text1 {
        color: #000000;
        font-size: 14px;
    }

    .toGroup {
        font-size: 14px;
        font-weight: bold;
    }

    /*.all{*/
    /*  margin: 20px 20px ;*/
    /*}*/
    .member {
        font-weight: bold;
        font-size: 16px;
        margin: 10px;
    }

    .me_text {
        font-size: 0.8rem;
        color: white;
        margin-left: 20px;
        margin-top: 20px;
    }

    .icon {
        margin-left: 20px;
    }

    .icon1 {
        float: right;
        margin-right: 50px;
    }

    .money {
        font-size: 13px;
        color: white;
        float: right;
        margin-right: 10px;
    }

    .diImage {
        padding-left: 20px;
        padding-bottom: 10px;
    }
</style>
